import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import ContractVersionPayrollPolicy from 'modules/contracts/store/models/ContractVersionPayrollPolicy'

export class ContractVersionsPayrollPolicies extends Collection<ContractVersionPayrollPolicy> {
  get indexes() {
    return ['contract_version_id', 'payroll_policy_id']
  }

  model() {
    return ContractVersionPayrollPolicy
  }
}

const singleton: ContractVersionsPayrollPolicies = new ContractVersionsPayrollPolicies()

export default singleton

const {
  provider: ContractVersionsPayrollPoliciesProvider,
  hook: useContractVersionsPayrollPolicies,
} = createCollectionContext<ContractVersionPayrollPolicy, ContractVersionsPayrollPolicies>()

export { ContractVersionsPayrollPoliciesProvider, useContractVersionsPayrollPolicies }
